import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineDataStreamPage, useAdminConfigurePipelinePropertiesPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineDataStreamsPage',
  setup(__props) {

    document.title = "Configure data streams"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorDataStreamsQuery,
        useChangeDataStreamCommand,
    } = useAdminConfigurePipelineDataStreamPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const dataStream = computed<string>(() => modelPipelineDetailsQueryV1.value?.DataStream)

    const { runConnectorDataStreamsQueryV1, modelConnectorDataStreamsQueryV1 } = useConnectorDataStreamsQuery(connectorId)
    const dataStreams = computed<string[]>(() => modelConnectorDataStreamsQueryV1.value?.DataStreams || [])

    const { invokeChangeDataStreamCommandV1, succeedChangeDataStreamCommandV1 } = useChangeDataStreamCommand(id, tid, userId)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

    watch(connectorId, () => {
        runConnectorDataStreamsQueryV1()
    })

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
    })

    watch(succeedChangeDataStreamCommandV1, () => succeedChangeDataStreamCommandV1.value && runPipelineDetailsQueryV1())

    function handleChangeDataStreamCommandV1(dataStream: string){
        invokeChangeDataStreamCommandV1({ DataStream: dataStream })
    }

return { __sfc: true,tid, id, connectorId, useCurrentUserQuery, usePipelineDetailsQuery, useConnectorDataStreamsQuery, useChangeDataStreamCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, dataStream, runConnectorDataStreamsQueryV1, modelConnectorDataStreamsQueryV1, dataStreams, invokeChangeDataStreamCommandV1, succeedChangeDataStreamCommandV1, handleChangeDataStreamCommandV1 }
}

})